import { CoreIcon } from '../core-icon';
import chevronRightCircleSVG from '../../assets/icons/chevron-right-circle.svg';
import type { IconProps } from '../core-icon';

export const ChevronRightCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chevronRightCircleSVG} {...props} />;
};
